import React from 'react'
import TrainerDemos from '../../views/trainer/demos/TrainerDemos'

function TrainerDemosPage() {
  return (
    <TrainerDemos />
  )
}

export default TrainerDemosPage